import React, { useState, useEffect } from 'react'
import {
  Panel,
  Row,
  Col,
  ControlLabel,
  Input,
  Form,
  Grid,
  FormGroup,
  SelectPicker,
  Message,
  RadioGroup,
  Radio,
  InputNumber,
  ButtonToolbar,
  IconButton,
  Icon,
} from 'rsuite'
// import { isRequired, isValidators, isRequiredFiled } from '../../../utils/ValidatorUtils'
import { getMaxLengthData, isValidators, requiredFiled } from '../../../utils/ValidatorUtils'
import ErrorMessage from '../../../components/message/errorMessage/ErrorMessage'
import ResultView from './ResultView'
import scrollToComponent from 'react-scroll-to-component'
import NumberFormat from 'react-number-format'
import ShowLimitLength from '../../../components/utils/ShowLimitLength'
import InputForm from '../../../components/forms/input/InputForm'
import CustomAlertMessageInfo from '../../CustomAlertMessageInfo'
// import { useForm, Controller } from 'react-hook-form'

export default function ResultForm({
  schema: _schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
  onSubmit,
  onDelete,
  getValues,
  onSelectConnection,
  isSubProject,
  ...props
}) {
  const { isDeleteError, isError, loading, scrollToEdtiForm, isCoordinator } = props
  const [schema, setSchema] = useState(_schema)
  const [objective, setObjective] = useState()
  const [objectiveResult, setObjectiveResult] = useState()
  const [indicatorsList, setIndicatorsList] = useState([])
  const [isAdd, setIsAdd] = useState(false)
  const [selectedId, setSelectedId] = useState()
  const [section, setSection] = useState()
  const [isDeleteFail, setIsDeleteFail] = useState(false)
  const [isSaveError, setIsSaveError] = useState(false)

  useEffect(() => {
    // console.log('useEffect schema', _schema)
    setObjectiveResult(_schema.objectiveResult.value)

    let indicators = [..._schema.indicatorsList.value]
    if (indicators.length == 0) {
      indicators.push(crateNewIndicator())
    }
    setIndicatorsList(indicators)
    // console.log('useEffect indicatorsList', indicators)
    setSchema(_schema)
    setIsAdd(isError)
    setIsDeleteFail(isDeleteError)
  }, [_schema])

  useEffect(() => {
    setIsSaveError(isError)
    setIsAdd(isError)
  }, [isError])

  useEffect(() => {
    setIsDeleteFail(isDeleteError)
  }, [isDeleteError])

  const crateNewIndicator = () => {
    let indicatorsObj = {
      indicators: '',
      indicatorType: '',
      count: '',
      unit: '',
      dataCollection: '',
      dataCollectionMethod: '',
    }

    return indicatorsObj
  }

  const handleAddIndicator = () => {
    let indicators = [...indicatorsList]
    // console.log('handleAddIndicator', indicators)

    let indicatorsObj = crateNewIndicator()

    indicators.push(indicatorsObj)

    setIndicatorsList(indicators)
  }

  const clearIndicator = () => {
    let indicators = []
    let indicatorsObj = crateNewIndicator()

    indicators.push(indicatorsObj)

    // console.log('clearIndicator', indicators)
    setIndicatorsList(indicators)
  }

  const handleDeleteIndicator = (index) => {
    // console.log('index', index)
    let indicators = [...indicatorsList]
    indicators.splice(index, 1)

    setIndicatorsList(indicators)
    setValue(schema.indicatorsList.name, indicators)
  }

  // const handleIndicatorChange = (value, index) => {
  //   let indicators = [...indicatorsList]
  //   let indicatorValue = indicators[index]
  //   indicatorValue.indicators = value
  //   indicators[index] = indicatorValue
  //   setIndicatorsList(indicators)
  //   setValue(schema.indicatorsList.name, indicators)
  // }

  const handleIndicatorTypeChange = (value, index) => {
    let indicators = [...indicatorsList]
    let indicatorValue = indicators[index]
    indicatorValue.indicatorType = value
    if (value == 0) {
      indicatorValue.count = ''
      indicatorValue.unit = ''
    }
    indicators[index] = indicatorValue
    setIndicatorsList(indicators)
    setValue(schema.indicatorsList.name, indicators)
  }

  const handleCountChange = (name, value, index) => {
    let indicators = [...indicatorsList]
    let indicatorValue = indicators[index]
    indicatorValue.count = value

    indicators[index] = indicatorValue
    setIndicatorsList(indicators)
    setValue(name, value)
    clearErrors(name)
    setValue(schema.indicatorsList.name, indicators)
  }

  // const handleUnitChange = (value, index) => {
  //   let indicators = [...indicatorsList]
  //   let indicatorValue = indicators[index]
  //   indicatorValue.unit = value

  //   indicators[index] = indicatorValue
  //   setIndicatorsList(indicators)
  //   setValue(schema.indicatorsList.name, indicators)
  // }

  const handleIndicatorsChange = (fieldName, value, index) => {
    let indicators = [...indicatorsList]
    let indicatorValue = indicators[index]
    indicatorValue[fieldName] = value

    indicators[index] = indicatorValue
    setIndicatorsList(indicators)

    // console.log('value', value)
    // console.log('fieldName_index', fieldName + '_' + index)
    // console.log(schema.indicatorsList.name, indicators)

    setValue(fieldName + '_' + index, value)
    setValue(schema.indicatorsList.name, indicators)
    clearErrors(fieldName + '_' + index)
  }

  // const onAddResult = () => {
  //   onSubmit()
  //   setObjective('')
  //   setObjectiveResult('')
  //   clearIndicator()
  // }

  const onAdd = () => {
    setObjective('')
    setObjectiveResult('')
    setSelectedId('')
    setValue('selectedId', '')
    setIsAdd(true)
    setIsSaveError(false)
    setIsDeleteFail(false)
    clearIndicator()
    scrollToEdtiForm()

    // scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
  }

  const onEdit = (data) => {
    // console.log('data.objective', data.objective, 'data.name', schema.objective.name)
    // console.log('data', data)

    setObjective(data.objective)
    setObjectiveResult(data.objectiveResult)
    setIndicatorsList(data.indicatorsList)
    setSelectedId(data.id)
    setValue(schema.objective.name, data.objective)
    setValue(schema.indicatorsList.name, data.indicatorsList)
    setValue('selectedId', data.id)

    setValue(
      schema?.indicators?.indicatorType?.name + '_' + data.index,
      data.indicatorsList[0]?.indicatorType
    )

    if (data.indicatorsList[0].indicatorType == 1) {
      setValue(schema.indicators.count.name + '_' + data.index, data.indicatorsList[0].count)
      setValue(schema.indicators.unit.name + '_' + data.index, data.indicatorsList[0].unit)
    }

    setIsDeleteFail(false)
    setIsAdd(true)
    setIsSaveError(false)
    setIsDeleteFail(false)
    scrollToEdtiForm()

    // scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
  }

  const indicatorFrom = (value, index) => {
    return (
      <Panel bordered style={{ marginTop: 10 }}>
        <Row>
          <Row>
            <Col xs={24} sm={24} md={24} lg={24}>
              <InputForm
                schema={schema.indicators}
                rows={2}
                componentClass="textarea"
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
                name={schema.indicators.name + '_' + index}
                value={value[schema.indicators.name]}
                onChange={(value) => {
                  handleIndicatorsChange(schema.indicators.name, value, index)
                }}
                index={index + 1}
              />
            </Col>
          </Row>
          <FormGroup controlId="radioList" style={{ marginBottom: 0 }}>
            <Row>
              <Col xs={24} sm={24} md={24} lg={24}>
                <ErrorMessage error={errors[schema.indicators.indicatorType.name + '_' + index]} />
                <Controller
                  key={schema.indicators.indicatorType.name + '_' + index}
                  name={schema.indicators.indicatorType.name + '_' + index}
                  control={control}
                  rules={isValidators(schema.indicators.indicatorType.validators)}
                  value={value[schema.indicators.indicatorType.name]}
                  defaultValue={value[schema.indicators.indicatorType.name]}
                  render={(props) => {
                    return (
                      <RadioGroup
                        inline
                        name={schema.indicators.indicatorType.name + '_' + index}
                        value={value[schema.indicators.indicatorType.name]}
                        onChange={(value) => {
                          handleIndicatorTypeChange(value, index)
                          // handleIndicatorsChange(schema.indicators.indicatorType.name, value, index)
                          props.onChange(value)
                        }}
                      >
                        {schema?.indicators?.indicatorType?.options?.map((item) => {
                          return <Radio value={item.value}>{item.label}</Radio>
                        })}
                      </RadioGroup>
                    )
                  }}
                />
              </Col>
            </Row>
          </FormGroup>
          {value[schema.indicators.indicatorType.name] == 1 && isSubProject && (
            <FormGroup>
              {/* <ControlLabel>
                {requiredFiled(schema.indicators.count.validators, schema.indicators.count.label)}
              </ControlLabel> */}
              <Row>
                <Row>
                  <Col xs={24} sm={24} md={12} lg={12}>
                    <ErrorMessage error={errors[schema.indicators.count.name + '_' + index]} />
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={12}>
                    <ErrorMessage error={errors[schema.indicators.unit.name + '_' + index]} />
                  </Col>
                </Row>
                <Col xs={24} sm={24} md={12} lg={12}>
                  <ControlLabel>
                    {requiredFiled(
                      schema.indicators.count.validators,
                      schema.indicators.count.label
                    )}
                  </ControlLabel>
                  <Controller
                    key={schema.indicators.count.name + '_' + index}
                    name={schema.indicators.count.name + '_' + index}
                    control={control}
                    rules={isValidators(schema.indicators.count.validators)}
                    value={value[schema.indicators.count.name]}
                    defaultValue={value[schema.indicators.count.name]}
                    render={(props) => {
                      return (
                        <NumberFormat
                          className="rs-input"
                          thousandSeparator={true}
                          value={value[schema.indicators.count.name]}
                          placeholder={
                            schema.indicators.count.hint || schema.indicators.count.label
                          }
                          onValueChange={(e) => {
                            handleCountChange(
                              schema.indicators.count.name + '_' + index,
                              e.floatValue,
                              index
                            )
                            props.onChange(e.floatValue)
                          }}
                        />
                      )
                    }}
                  />
                </Col>

                <Col xs={24} sm={24} md={12} lg={12}>
                  <ControlLabel>
                    {requiredFiled(schema.indicators.unit.validators, schema.indicators.unit.label)}
                  </ControlLabel>
                  <Controller
                    key={schema.indicators.unit.name + '_' + index}
                    name={schema.indicators.unit.name + '_' + index}
                    control={control}
                    rules={isValidators(schema.indicators.unit.validators)}
                    value={value[schema.indicators.unit.name]}
                    defaultValue={value[schema.indicators.unit.name]}
                    render={(props) => {
                      return (
                        <Input
                          //name={schema.indicators.unit.name + '_' + index}
                          placeholder={schema.indicators.unit.hint || schema.indicators.unit.label}
                          value={value[schema.indicators.unit.name]}
                          //inputRef={register(isValidators(schema.indicators.unit.validators))}
                          onChange={(value) => {
                            // handleUnitChange(value, index)
                            handleIndicatorsChange(schema.indicators.unit.name, value, index)
                            props.onChange(value)
                          }}
                        />
                      )
                    }}
                  />
                  {/* <Input
                    name={schema.indicators.unit.name + '_' + index}
                    placeholder={schema.indicators.unit.hint || schema.indicators.unit.label}
                    value={value[schema.indicators.unit.name]}
                    inputRef={register(isValidators(schema.indicators.unit.validators))}
                    onChange={(value) => {
                      // handleUnitChange(value, index)
                      handleIndicatorsChange(schema.indicators.unit.name, value, index)
                    }}
                  /> */}
                </Col>
              </Row>
            </FormGroup>
          )}

          {schema.indicators.dataCollection && (
            <Col xs={24} sm={24} md={24} lg={24}>
              <InputForm
                schema={schema.indicators.dataCollection}
                rows={2}
                componentClass="textarea"
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
                name={schema.indicators.dataCollection.name + '_' + index}
                value={value[schema.indicators.dataCollection.name]}
                onChange={(value) => {
                  handleIndicatorsChange(schema.indicators.dataCollection.name, value, index)
                }}
              />
            </Col>
          )}

          {schema.indicators.dataCollectionMethod && (
            <Col xs={24} sm={24} md={24} lg={24}>
              <InputForm
                schema={schema.indicators.dataCollectionMethod}
                rows={2}
                componentClass="textarea"
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
                name={schema.indicators.dataCollectionMethod.name + '_' + index}
                value={value[schema.indicators.dataCollectionMethod.name]}
                onChange={(value) => {
                  handleIndicatorsChange(schema.indicators.dataCollectionMethod.name, value, index)
                }}
              />
            </Col>
          )}

          <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 5, textAlign: 'right' }}>
            <IconButton
              appearance="ghost"
              className="rs-btn-ghost-cancel"
              icon={<Icon className="bt-gost-icon-radius-cancel" icon="trash" />}
              onClick={(e) => handleDeleteIndicator(index)}
            >
              ลบตัวชี้วัด
            </IconButton>
          </Col>
        </Row>
      </Panel>
    )
  }

  return (
    <>
      <Form>
        <Panel
          eventKey={1}
          ref={(section) => {
            setSection(section)
          }}
        >
          {!isCoordinator && (
            <Grid fluid>
              <Controller
                key={'selectedId'}
                name={'selectedId'}
                control={control}
                defaultValue={selectedId}
              />
              <Controller key={'id'} name={'id'} control={control} defaultValue={selectedId} />
              {schema.description && (
                <div style={{ marginBottom: 10 }}>
                  <CustomAlertMessageInfo contents={schema.description} />
                </div>
              )}

              {isAdd ? (
                <>
                  {/* <FormGroup
                  ref={(section) => {
                    setSection(section)
                  }}
                > */}
                  <Row>
                    <Col xs={24} sm={24} md={24} lg={24}>
                      <ErrorMessage error={errors[schema.objective.name]} />
                      <ControlLabel>
                        {requiredFiled(schema.objective.validators, schema.objective.label)}
                      </ControlLabel>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={24}>
                      <Controller
                        key={schema.objective.name}
                        name={schema.objective.name}
                        control={control}
                        rules={isValidators(schema.objective.validators)}
                        defaultValue={objective}
                        render={(props) => {
                          return (
                            <SelectPicker
                              data={schema.objective.options}
                              style={{ width: '100%' }}
                              searchable={false}
                              placeholder={schema.objective.hint}
                              value={props.value}
                              onChange={(e) => {
                                setObjective(e)
                                setValue(schema.objective.name, e)
                                clearErrors(schema.objective.name)
                              }}
                            />
                          )
                        }}
                      />
                    </Col>
                  </Row>
                  {/* </FormGroup> */}

                  {/* <FormGroup> */}
                  <Row>
                    <Col xs={24} sm={24} md={24} lg={24}>
                      <InputForm
                        schema={schema.objectiveResult}
                        rows={2}
                        componentClass="textarea"
                        register={register}
                        Controller={Controller}
                        control={control}
                        errors={errors}
                        setValue={setValue}
                        clearErrors={clearErrors}
                        value={objectiveResult}
                        onChange={(value) => {
                          setObjectiveResult(value)
                        }}
                      />
                    </Col>
                  </Row>
                  {/* </FormGroup> */}

                  <Row style={{ marginTop: 10 }}>
                    {/* <Col xs={24} sm={24} md={24} lg={24}>
                    <ControlLabel>{requiredFiled(schema.indicators.validators, schema.indicatorsText.label)}</ControlLabel>
                  </Col> */}
                  </Row>
                  {/* <Panel bordered style={{ marginBottom: 5 }}> */}
                  <Form fluid>
                    <Controller
                      key={schema.indicatorsList.name}
                      name={schema.indicatorsList.name}
                      control={control}
                      rules={isValidators(schema.indicatorsList.validators)}
                      defaultValue={indicatorsList}
                    />

                    {indicatorsList &&
                      indicatorsList.map((item, index) => {
                        return indicatorFrom(item, index)
                      })}

                    <Row>
                      <Col
                        xs={24}
                        sm={24}
                        md={24}
                        lg={24}
                        style={{ marginTop: 5, marginBottom: 5, textAlign: 'right' }}
                      >
                        <IconButton
                          appearance="ghost"
                          icon={<Icon className="bt-gost-icon-radius" icon="plus" />}
                          onClick={(e) => handleAddIndicator()}
                          style={{ marginRight: 5 }}
                        >
                          เพิ่มตัวชี้วัด
                        </IconButton>
                      </Col>
                    </Row>
                  </Form>
                  {/* </Panel> */}
                  {isSaveError && (
                    <Row style={{ marginBottom: 10 }}>
                      <Message
                        showIcon
                        type="error"
                        description={`บันทึก ${schema.buttonText || ''} ไม่สำเร็จ`}
                      />
                    </Row>
                  )}
                  <FormGroup style={{ marginTop: 20 }}>
                    <ButtonToolbar>
                      <div>
                        <IconButton
                          appearance="ghost"
                          className={selectedId ? 'rs-btn-ghost-save' : 'rs-btn-ghost-save'}
                          icon={
                            <Icon
                              icon={selectedId ? 'edit' : 'save'}
                              className={selectedId ? 'bt-gost-icon-radius' : 'bt-gost-icon-radius'}
                            />
                          }
                          disabled={loading}
                          onClick={() => {
                            onSubmit()
                          }}
                        >
                          {selectedId ? 'บันทึกแก้ไข' : 'บันทึก'}
                          {schema.buttonText || ''}
                        </IconButton>{' '}
                        <IconButton
                          appearance="ghost"
                          className="rs-btn-ghost-cancel"
                          icon={<Icon className="bt-gost-icon-radius-cancel" icon="close" />}
                          onClick={(e) => {
                            setIsAdd(false)
                          }}
                          style={{ marginRight: 5 }}
                          disabled={loading}
                        >
                          ยกเลิก
                        </IconButton>
                      </div>
                    </ButtonToolbar>
                  </FormGroup>
                </>
              ) : (
                <Row style={{ marginTop: '10px' }}>
                  <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 5, marginBottom: 5 }}>
                    <div>
                      <IconButton
                        appearance="ghost"
                        icon={<Icon className="bt-gost-icon-radius" icon="plus" />}
                        onClick={() => {
                          onAdd()
                        }}
                        style={{ marginRight: 5 }}
                      >
                        {'เพิ่ม'}
                        {schema.buttonText || ''}
                      </IconButton>
                    </div>
                  </Col>
                </Row>
              )}
            </Grid>
          )}
        </Panel>

        {isDeleteFail && (
          <Message showIcon type="error" description={`ลบ ${schema.buttonText || ''} ไม่สำเร็จ`} />
        )}

        {/* {!reloadTable && ( */}
        <ResultView
          schema={schema}
          isEdit={true}
          onEdit={(data) => {
            onEdit(data)
          }}
          onDelete={onDelete}
          onSelectConnection={onSelectConnection}
          isCoordinator={isCoordinator}
          isSubProject={isSubProject}
        />
        {/* )} */}
      </Form>
    </>
  )
}
